import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 
import authReducer from './slices/authSlice'; 
import userReducer from './userSlice'; 
import startupReducer from './startup/startupSlice';
import documentReducer from './startup/documents/documentSlice';
import teamReducer from './startup/team/teamSlice';
import marketReducer from './startup/market/marketSlice';
import analysisReducer from './startup/analysis/analysisSlice';
import riskReducer from './startup/risk/riskSlice';
import fundingReducer from './startup/funding/fundingSlice';
import companyReducer from './startup/company/companySlice';
import profileReducer from './startup/profile/profileSlice';
import projectDetailsReducer from './startup/aboutProduct/projectDetailsSlice';
import processReducer from './startup/aboutProduct/processSlice';
import otherTopicsReducer from './startup/aboutProduct/OtherTopicsSlice';
import approvalReducer from './startup/approval/approvalSlice';
import campaignDetailReducer from './startup/campaignDetail/campaignDetailSlice';
import mediaReducer from './startup/media/mediaSlice';
import adminReducer from './slices/adminSlice';
import mailTemplatesReducer from './slices/mailTemplatesSlice';
import committeeMembersReducer from './slices/committeeMembersSlice';
import mailReducer from './slices/mailSlice'
import heroReducer from './slices/heroSlice';
import { combineReducers } from 'redux'; // Import combineReducers from redux
const persistConfig = {
    key: 'root', 
    storage,
    whitelist: ['auth'], 
};

const rootReducer = combineReducers({
    auth: authReducer, 
    user: userReducer, 
    startup: startupReducer,
    documents: documentReducer,
    team: teamReducer,
    market: marketReducer,
    analysis: analysisReducer,
    risk: riskReducer,
    funding: fundingReducer,
    company: companyReducer,
    profile: profileReducer,
    projectDetails: projectDetailsReducer,
    process: processReducer,
    otherTopics: otherTopicsReducer,
    approval: approvalReducer,
    campaignDetail: campaignDetailReducer,
    media: mediaReducer,
    admin: adminReducer,
    mailTemplates: mailTemplatesReducer,
    committeeMembers: committeeMembersReducer,
    mail: mailReducer,
    hero: heroReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, 
        }),
});

export const persistor = persistStore(store);

export default store;
